export default [
  {
    path: '/products',
    name: 'products',
    component: r => require(['views/layout/Main'], r),
    redirect: '/products/list',
    children: [
      {
        path: 'list',
        name: 'products-list',
        component: r => require(['views/products/Main'], r)
      }
      // {
      //   path: 'form',
      //   name: 'sn-form',
      //   component: r => require(['views/products/children/Form'], r)
      // }
    ]
  }
]
